import { themeColors, themeTextColors } from "@common/constants";
import { FC, useState } from "react";
import { HiStar } from "react-icons/hi";
import IntakeForm from "@modules/tasks/components/IntakeForm";
import { Dialog, Typography } from "@earned/core";

interface IntakeFormModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const IntakeFormModal: FC<IntakeFormModalProps> = ({ isOpen, onClose }) => {
  const [currentPage, setCurrentPage] = useState(1);
  return (
    <Dialog
      isOpen={isOpen}
      onClose={() => {
        setCurrentPage(1);
        onClose();
      }}
      title={`${currentPage == 1 ? "Client Onboarding" : "Add Co-Client"}`}
      subtitle={
        <div className="flex flex-row items-center text-label-xs text-purple-2-300">
          <Typography variant="body-xs" color="danger">
            Required
          </Typography>
          <HiStar
            className="mb-1 h-[20px] w-[7px]"
            color={themeTextColors.danger}
          />
        </div>
      }
      size="lg"
      classNames={{
        Panel: "max-w-[800px]",
      }}
    >
      <IntakeForm
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        onClose={() => {
          setCurrentPage(1);
          onClose();
        }}
      />
    </Dialog>
  );
};

export default IntakeFormModal;
